import { API_BASE } from "@/lib/api-config";

export type RemoteSession = {
  access_token: string;
  refresh_token: string;
  expires_in: number;
  expires_at?: number;
  token_type: string;
};

export type AuthSuccessBody = {
  user: { id: string; email: string | null } | null;
  session: RemoteSession | null;
};

function messageFromApiErrorBody(body: { error?: unknown }): string {
  const e = body.error;
  if (typeof e === "string") return e;
  if (e && typeof e === "object") {
    const fe = e as { formErrors?: string[]; fieldErrors?: Record<string, string[] | string[][] | unknown> };
    if (fe.formErrors?.length) return String(fe.formErrors[0]);
    const fieldErrors = fe.fieldErrors;
    if (fieldErrors && typeof fieldErrors === "object") {
      for (const key of Object.keys(fieldErrors)) {
        const v = fieldErrors[key];
        if (Array.isArray(v) && v.length > 0) {
          const first = v[0];
          if (typeof first === "string") return first;
        }
      }
    }
  }
  return "Permintaan gagal";
}

export async function apiRegister(email: string, password: string): Promise<AuthSuccessBody> {
  const res = await fetch(`${API_BASE}/api/v1/auth/register`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  const data = (await res.json()) as AuthSuccessBody & { error?: unknown };
  if (!res.ok) {
    throw new Error(messageFromApiErrorBody(data));
  }
  return data;
}

export async function apiLogin(email: string, password: string): Promise<AuthSuccessBody> {
  const res = await fetch(`${API_BASE}/api/v1/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  const data = (await res.json()) as AuthSuccessBody & { error?: unknown };
  if (!res.ok) {
    throw new Error(messageFromApiErrorBody(data));
  }
  return data;
}

/** POST /api/v1/auth/refresh — memakai refresh_token Supabase (tanpa Bearer). */
export async function apiRefresh(refreshToken: string): Promise<AuthSuccessBody> {
  const res = await fetch(`${API_BASE}/api/v1/auth/refresh`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refresh_token: refreshToken }),
  });
  const data = (await res.json()) as AuthSuccessBody & { error?: unknown };
  if (!res.ok) {
    throw new Error(messageFromApiErrorBody(data));
  }
  return data;
}

export function getAuthHeader(accessToken: string | undefined): HeadersInit | undefined {
  if (!accessToken) return undefined;
  return { Authorization: `Bearer ${accessToken}` };
}
